import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import LearnMore from 'kosmos/components/LearnMore';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '80%',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

export default function LearnMoreModal({
  openLearnMoreTabId,
  onClose,
}: {
  openLearnMoreTabId: string;
  onClose: () => void;
}) {
  const open = Boolean(openLearnMoreTabId);

  return (
    <div>
      <Modal
        open={open}
        onClose={onClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography
            sx={{ mb: 3, fontWeight: 'bold' }}
            id="modal-modal-title"
            variant="h6"
            component="h2"
          >
            Smart Environmental, Social & Governance Scoring Information
          </Typography>
          {onClose ? (
            <IconButton
              aria-label="close"
              onClick={onClose}
              sx={{
                position: 'absolute',
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
          ) : null}
          <LearnMore initialTabId={openLearnMoreTabId} />
        </Box>
      </Modal>
    </div>
  );
}
